// Account.tsx
import { useState } from "react";
import { useAuth } from "../../Hooks/useAuth";
import googleSignInImage from "../../web_light_sq_SI@4x.png";

const Account = () => {
	const {
		user,
		signIn,
		signInWithGoogle,
		deleteUserAccount,
		error,
		successMessage,
	} = useAuth();
	const [email, setEmail] = useState("");
	const [password, setPassword] = useState("");

	const handleSignIn = async () => {
		signIn(email, password);
	};

	const handleDeleteAccount = () => {
		if (
			window.confirm(
				"Are you sure you want to delete this account? This cannot be undone.",
			)
		) {
			deleteUserAccount();
		}
	};

	if (!user) {
		return (
			<div className="account-container">
				<h1>Sign In To Manage Your Account</h1>
				{error && <div className="danger-alert">{error}</div>}

				<div className="form-group">
					<label htmlFor="email">Email</label>
					<input
						type="email"
						id="email"
						value={email}
						onChange={e => setEmail(e.target.value)}
					/>
				</div>

				<div className="form-group">
					<label htmlFor="password">Password</label>
					<input
						type="password"
						id="password"
						value={password}
						onChange={e => setPassword(e.target.value)}
					/>
				</div>

				<button
					style={{
						width: "150px",
						backgroundColor: "blue",
						color: "white",
					}}
					onClick={handleSignIn}
				>
					Sign In
				</button>

				<hr />

				<button className="google-btn" onClick={signInWithGoogle}>
					<img
						src={googleSignInImage}
						alt="Google Sign In"
						style={{ width: "150px", height: "auto" }}
					/>
				</button>
			</div>
		);
	}

	if (successMessage) {
		return (
			<div className="account-container">
				<h1>{successMessage}</h1>
			</div>
		);
	}

	return (
		<div className="account-container">
			<h1>Account Details</h1>
			<div style={{ textAlign: "left" }}>
				<p>Name: {user.displayName}</p>
				<p>Email: {user.email}</p>
			</div>
			{error && <div className="danger-alert">{error}</div>}
			<button
				style={{ backgroundColor: "red", padding: 10, color: "white" }}
				onClick={handleDeleteAccount}
			>
				Delete Account
			</button>
		</div>
	);
};

export default Account;
